module.exports = __webpack_public_path__ + "assets/img/out_(5).404bb618.gif";